import styled from 'styled-components';
import lineRom from '../../assets/icons/line-gradient-rom.png';
import lineStrength from '../../assets/icons/line-gradient-strength.png';

interface ItemProps {
  readonly unit?: string;
  readonly ruleColor?: string;
}

export const BoxInfo = styled.div`
  background: #ffffff;
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  display: flex;
  overflow: hidden;
  width: 48%;
`;

export const BoxLeft = styled.div`
  border-right: 1px solid #eeeff1;
  min-width: 162px;
`;

export const BoxLeftHead = styled.div`
  background-color: var(--DarkGray);
  padding: 10px 15px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  color: #fff;
`;

export const BoxLeftContent = styled.div``;

export const BoxLeftInfo = styled.div`
  align-items: center;
  background-color: #f7f8fa;
  border-radius: 6px;
  width: min-content;
  margin: 8px auto;
  display: flex;
`;

export const BoxLeftValue = styled.div`
  background-color: #fff;
  border: 1px solid #e6e7e9;
  border-radius: 6px;
  color: var(--DarkGray);
  font-size: 25px;
  font-weight: 600;
  min-width: 76px;
  text-align: center;
  padding: 12px 0;
`;

export const BoxLeftUnit = styled.div`
  color: var(--DarkGray);
  font-weight: 500;
  padding: 0 10px;
  font-size: 12px;
`;

export const BoxLeftBottom = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;

  & span:first-of-type {
    color: #5d6e81;
    font-weight: 600;
    font-size: 12px;
  }

  & span:last-of-type {
    margin-left: 5px;
    color: #5d6e81;
    font-weight: 400;
    font-size: 12px;
  }
`;

export const BoxRight = styled.div`
  flex: 1 1;
`;

export const BoxRightHeader = styled.div`
  align-items: center;
  background-color: #f8f9fa;
  box-shadow: 0px 1px 0 rgba(255, 255, 255, 1) inset;
  color: var(--DarkGray);
  display: flex;
  justify-content: center;
  font-size: 12px;
  height: 37px;
`;

export const BoxRightHeaderItem = styled.div`
  padding: 0 5px;
`;

export const BoxRightHeaderItemSpecial = styled.b`
  display: inline-flex;
  justify-items: center;
`;

export const BoxRightHeaderItemInfo = styled.span`
  display: inline-flex;
  margin-right: 2px;
`;

export const BoxRightContent = styled.div`
  color: #474f58;
  font-size: 10px;
`;

export const BoxRuleWrapper = styled.div`
  padding: 35px 20px 20px;
  position: relative;
  text-align: center;
`;

export const BoxRule = styled.div<ItemProps>`
  background-image: ${props => {
    return props.unit === 'lbs.' ? `url(${lineStrength})` : `url(${lineRom})`;
  }};
  background-repeat: no-repeat;
  background-position: center;
  max-width: 380px;
  margin: 0 auto;
  height: 16px;
  width: 100%;
`;

export const BoxRuleScale = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 380px;
  margin: 0 auto;
  padding-top: 3px;
  width: 100%;
`;

export const BoxRuleScaleItem = styled.span`
  display: inline-block;
  line-height: 13px;
`;

export const BoxRuleSpot = styled.div`
  color: var(--DarkGray);
  font-size: 11px;
  left: 56%;
  margin-left: -78px;
  position: absolute;
  top: 8px;
  width: 110px;
`;

export const BoxRuleSpotValue = styled.span<ItemProps>`
  background-color: ${props => props.ruleColor};
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  margin-left: 5px;
  margin-right: 5px;
  padding: 3px 4px;
  position: relative;
`;
